/* eslint-disable max-len */

import { ContractObligationVersions } from '../../../../interfaces/TermsAndConditions.types';

export const contractObligationContentJapan: Record<ContractObligationVersions, string> = {
  [ContractObligationVersions.V1]: `<div>
  <div class="contract-obligation-content__heading">
    <div class="contract-obligation-content__text">ケルヒャーコネクト カスタマーポータル利用規約（参考和訳）</div>
  </div>
  <div class="contract-obligation-content__subheading">
    <div class="contract-obligation-content__text">第1条 総則</div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">1.1</div>
    <div class="contract-obligation-content__text">ケルヒャーコネクト カスタマーポータル利用に関する一般契約条件（以下、「本規約」という）は、ケルヒャージャパン株式会社神奈川県横浜市港北区大豆戸町639番3号、以下、「ケルヒャー」という。）が提供するサービスに適用され、ドイツ民法典（BGB）第310条(1)に定める事業者、私法もしくは公法上の法人、または公法上の特別財産（以下、「お客様」という。）のみを対象とします。
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">1.2</div>
    <div class="contract-obligation-content__text">お客様を代表して初めてケルヒャーカスタマーポータルに登録し、本規約に同意する場合、貴殿は、本規約にお客様を拘束する権限を有することをケルヒャーに対し表明し保証するものとします。かかる権限を有しない場合、または貴殿もしくはお客様が本規約に拘束されることに同意しない場合、貴殿は本規約に同意してはならず、貴殿およびお客様は契約上のサービスを利用することはできないものとします。
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">1.3</div>
    <div class="contract-obligation-content__text">本規約においては、お客様の一般取引条件（もし存在する場合）は適用されないものとします。
    </div>
  </div>
  <div class="contract-obligation-content__subheading">
    <div class="contract-obligation-content__text">第2条 契約の目的物に関する一般情報
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">2.1</div>
    <div class="contract-obligation-content__text">ケルヒャーは、事業者のお客様向けに、イクイップメントマネジメント（機器管理）システムの一部として「カスタマーポータル」を提供します。これは、ウェブブラウザから安全にアクセスでき、お客様がお持ちの複数の機器や設備を簡単に管理するためのソフトウェアです。
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">2.2</div>
    <div class="contract-obligation-content__text">お客様がカスタマーポータルで利用できる個々のデータおよび機能は、お客様が使用する機器のモデル、ならびにデータ送信用のハードウェアモジュールが当該モデルに搭載されているかどうか、また搭載されている場合はその種類によって異なります。各ハードウェアモジュールの機能および取得できるデータの概要は、ハードウェアモジュールに関する仕様書に含まれるか、またはご要望要請に応じてケルヒャーからご提供します。
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">2.3</div>
    <div class="contract-obligation-content__text">カスタマーポータルの基本的な登録情報や主要機能（以下、「ケルヒャーコネクト」という。）は、データ送信用のハードウェアモジュールが内蔵されていないケルヒャー製品および他社製品のどちらでもご利用いただけます。
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">2.4</div>
    <div class="contract-obligation-content__text">ほぼリアルタイムのデータおよび追加機能をカスタマーポータル経由で利用できるようにするには、お客様がお持ちの各機器にデータ送信用のハードウェアモジュールが装備されているか、後から取り付ける必要があります。
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">2.5</div>
    <div class="contract-obligation-content__text">お客様は、清掃対象の建物、清掃時間、または各機器の使用状況に関する情報など、お客様自身固有や機器に関する固有の追加情報（以下、「ポータルデータ」という。）をカスタマーポータルに入力することができます。
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">2.6</div>
    <div class="contract-obligation-content__text">ケルヒャーは、お客様に対し、カスタマーポータルへのアクセスおよび利用を許諾します。
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">2.7</div>
    <div class="contract-obligation-content__text">ケルヒャーがお客様のアカウントを設定した後、お客様はウェブアドレス https://em.kaercher.com/ からカスタマーポータルにアクセスできます。
アクセスには、以下のウェブブラウザおよびオペレーティングシステムの最新バージョンをご利用いただけます。
ウェブブラウザ：Google Chrome、Microsoft Edge、Mozilla Firefox、Apple Safari
オペレーティングシステム：Microsoft Windows
これら以外のウェブブラウザやオペレーティングシステムでは、アクセスが制限される場合があります。 なお、スマートフォンやタブレットなどのモバイル端末からのアクセスはサポートしておりません。

    </div>
  </div>
  <div class="contract-obligation-content__subheading">
    <div class="contract-obligation-content__text">第3条 契約の成立</div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">3.1</div>
    <div class="contract-obligation-content__text">ケルヒャーは、お客様からのご要望に応じて、アクセスデータ（例：ユーザー名、初期パスワード）およびカスタマーポータルへのリンクを提供します。お客様からのご要望は、電話または電子メールなど、特定の形式を問わずお伝えいただけます。お客様は、ケルヒャーから提供されたアクセスデータを使用してポータルにログインし、その際に本規約に同意いただくことができます。ケルヒャーコネクトシステムの利用に関するケルヒャーとお客様との間の契約は、お客様がログイン本規約に同意された時点で成立します。お客様の要請で示された連絡担当者は、管理者としてお客様アカウントに登録され、管理者としてお客様アカウント内で他の従業員様に対する追加のアクセス権限を設定することができます。
    </div>
  </div>
  <div class="contract-obligation-content__subheading">
    <div class="contract-obligation-content__text">第4条 保守および可用性</div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">4.1</div>
    <div class="contract-obligation-content__text">カスタマーポータルの稼働状況は、月曜日から金曜日の午前9時から午後4時（中央ヨーロッパ時間、以下「サービス時間」といいます。）まで監視しています。ただし、ドイツ（バーデン＝ヴュルテンベルク州）の祝日を除きます。万が一、重大な障害（例：カスタマーポータルが使用できなくなった場合、またはその使用が著しく制限された場合など）が発生した場合は、サービス時間内に、障害を検知次第、またはお客様からのご連絡に基づき、速やかに保守作業を開始します。ケルヒャーは、この保守作業について、カスタマーポータルまたは電子メールでお客様に速やかにお知らせし、技術的条件に従って可能な範囲でできるだけ短時間で作業を完了するよう努めます。<br> ケルヒャーは、この保守作業について、カスタマーポータルまたは電子メールでお客様に速やかにお知らせし、技術的に可能な範囲で、できるだけ短時間で作業を完了するよう努めます。
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">4.2</div>
    <div class="contract-obligation-content__text">カスタマーポータルの可用性（稼働率）は、保守期間を除き、年間平均で98%とします。
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">4.3</div>
    <div class="contract-obligation-content__text">ケルヒャーは、保守作業を実施するために、サービス時間外にサービスの提供を中断することがあります。その際、ケルヒャーは、カスタマーポータルまたは電子メールにて、具体的な保守期間を5日前までにお客様にお知らせするよう努めます。ただし、予定外の保守作業や緊急の障害対応が必要となり、5日前の事前通知が現実的に困難な場合には、サービス中断の時間および期間について、できる限り速やかにお客様にお知らせします。 計画された定期保守作業（「計画保守作業」）中は、お客様はソフトウェアアプリケーションをご利用いただくことはできません。
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">4.4</div>
    <div class="contract-obligation-content__text">お客様およびお客様のユーザー様がお使いのデバイスとインターネット間の接続に問題がある場合（例：回線の故障、他のプロバイダーまたは通信事業者の障害など）、または提供されたシステム容量が本規約の条件に違反して使用された場合、ケルヒャーが対応すべき障害とはみなしません。
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">4.5</div>
    <div class="contract-obligation-content__text">クラウドベースのソフトウェアアプリケーション（カスタマーポータル）とお客様の機器との接続に問題がある場合、各機器のデータがカスタマーポータルで利用できなくなることがあります。ケルヒャーの責任範囲外である接続問題の場合、本規約において、サービスは利用不可とはみなされないものとします。ケルヒャーが責任を負わない接続の問題には、特に、大気の状態（悪天候など）、地形的要因、または橋、トンネル、建物などの障害物によるものが含まれます。
    </div>
  </div>
  <div class="contract-obligation-content__subheading">
    <div class="contract-obligation-content__text">第5条 ソフトウェアアプリケーションの使用権</div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">5.1</div>
    <div class="contract-obligation-content__text">ケルヒャーは、本規約の規定に従い、契約期間中、お客様に対して、ソフトウェアアプリケーションを使用するための非独占的、譲渡不能かつ再許諾（サブライセンス）不能な権利を付与します。
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">5.2</div>
    <div class="contract-obligation-content__text">カスタマーポータルにおける「ニアリアルタイム」データの表示およびその他の追加機能に関する情報は、ハードウェアモジュールに関する仕様書でご確認いただくか、ご要望に応じてケルヒャーから提供します。
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">5.3</div>
    <div class="contract-obligation-content__text">お客様は、契約期間中、有償無償を問わず、第三者にソフトウェアの使用を許可することはできません。ただし、お客様に代わって、またはお客様によって付与されたアクセス権に基づいて、フリートおよびケルヒャーコネクトの目的で無償かつ意図された範囲内でサービスを使用する方（例：お客様の管理ユーザーおよび従業員の方々）は、ここでの第三者には該当しません。したがって、お客様はソフトウェアを転貸することは固く禁止されています。
    </div>
  </div>
  <div class="contract-obligation-content__subheading">
    <div class="contract-obligation-content__text">第6条 機器データおよびポータルデータに関する権利</div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">6.1</div>
    <div class="contract-obligation-content__text">Alfred Kärcher SE & Co. KG（以下、「AKW」といいます。）は、データ送信用のハードウェアモジュールによって収集され、カスタマーポータルで処理される機器データ（以下、「機器データ」という。）の所有者であり、これらの機器データに関する一切の権利を単独で保有します。これは、データが収集されている機器の所有者が誰であるかにかかわらず同様に適用されます。
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">6.2</div>
    <div class="contract-obligation-content__text">さらに、お客様は、AKWに対し、お客様が入力したポータルデータを、AKWの内部目的（特に市場調査および製品改善のため）に、匿名化された形式で、期間や地域の制限なく使用できる、非独占的かつ取消不能な権利を許諾します。
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">6.3</div>
    <div class="contract-obligation-content__text">処理されたデータにお客様の営業秘密が含まれる場合、お客様は、AKWおよびケルヒャーに対し、かかるデータを匿名化した上で、AKWおよびケルヒャー自身の事業目的（特に、本規約に基づくサービスおよびケルヒャーの他の製品の改善を目的とした分析・評価）のために使用できる、永続的、取消不能、非独占的かつ譲渡不可能な権利を許諾します。AKWおよびケルヒャーは、本規約の第15条に従い、かかるデータを厳格に秘密として取り扱うものとします。
    </div>
  </div>
  <div class="contract-obligation-content__subheading">
    <div class="contract-obligation-content__text">第7条 お客様の義務</div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">7.1</div>
    <div class="contract-obligation-content__text">お客様は、カスタマーポータルに何らかの障害またはエラーが発生した場合、その発生後できるだけ速やかに、カスタマーポータルで設置されている連絡フォームを使用するか、カスタマーポータルで提供されるサービス用メールアドレス宛にケルヒャーに連絡するものとします。
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">7.2</div>
    <div class="contract-obligation-content__text">お客様は、カスタマーポータルのアカウント情報の一部として、連絡担当者（管理者）を指定するものとし、当該担当者は、通常の営業時間中に、本規約に基づくサービスおよび契約そのものに関するケルヒャーからのあらゆる質問にも対応できるようにするものとします。連絡担当者が対応できない範囲については、お客様は代理人を指定するものとします。ご指定いただいた連絡担当者およびその代理人は、カスタマーポータルの管理および使用に関してお客様を代表して決定を行う権限を有するものとします。
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">7.3</div>
    <div class="contract-obligation-content__text">カスタマーポータルへのアクセス権は、お客様によって承認された従業員および代理人にのみお客様が付与することができます。お客様は、アクセス権を秘密に保持し、第三者がアクセスできないようにする義務を負うものとします。お客様は、お客様の従業員および代理人にも同様に義務を課すものとします。さらに、アクセス権およびアカウントが不正に使用される可能性、ならびにカスタマーポータルに関連するその他のセキュリティ上の問題について、遅滞なくケルヒャーに通知する義務を負うものとします。
    </div>
  </div>
  <div class="contract-obligation-content__subheading">
    <div class="contract-obligation-content__text">第8条 料金</div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">8.1</div>
    <div class="contract-obligation-content__text">Tお客様は、カスタマーポータルのケルヒャーコネクトを無料でご利用できます。
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">8.2</div>
    <div class="contract-obligation-content__text">ハードウェアモジュールの提供後最初の5年間は、「ニアリアルタイム」データおよびケルヒャーコネクト以外のカスタマーポータルの追加機能の使用にかかる料金は、購入価格、または（該当する場合は）データ送信用のハードウェアモジュールの使用許可料に含まれるものとします。この5年間の期間満了後、使用権は有償で更新することができるものとします。
    </div>
  </div>
  <div class="contract-obligation-content__subheading">
    <div class="contract-obligation-content__text">第9条 サービスの変更</div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__text">ケルヒャーは、技術的な理由または下請業者の変更により必要となる範囲において、本規約に基づくサービス内容を調整する権利を有します。サービス内容の変更は、お客様のご利用に著しい影響を与えるものではなく、また、お客様にとって不合理なものであってはなりません。ケルヒャーがサービス範囲を拡大することは、いつでも可能です。ただし、ケルヒャーは、カスタマーポータルの新機能などの拡張大されたサービス範囲について、追加料金をお支払いいただいた場合にのみお客様がご利用できるようにすることができます。
    </div>
  </div>
  <div class="contract-obligation-content__subheading">
    <div class="contract-obligation-content__text">第10条 下請業者</div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__text">ケルヒャーは、サービスを提供するために下請業者を利用することがあります。下請業者の選定に関しては、ケルヒャーが一切の裁量権を持ちます。ただし、ケルヒャーは、ケルヒャーが把握している範囲で、お客様の正当な利益を考慮して、相当な注意を払って下請業者を選定するものとします。下請業者を選定する権利には、契約期間中に下請業者を交代させる権利も含まれるものとします。ただし、かかる交代がお客様の正当な利益を不当に損なう場合を除きます。
    </div>
  </div>
  <div class="contract-obligation-content__subheading">
    <div class="contract-obligation-content__text">第11条 権利侵害の場合のお客様アカウントのブロック
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__text">データの収集または使用が違法である、または第三者の権利を侵害していると疑われる合理的な理由がある場合、ケルヒャーは、カスタマーポータル内のお客様アカウントを直ちに停止（ブロック）権利を有するものとします。特に、一般データ保護規則（GDPR）の規定に違反して実行されるデータ処理活動は、第三者の権利の侵害にあたります（この点については、後述の第14条をご参照ください）。データが違法に収集または利用された、および/または権利侵害が発生したという疑いが生じるのは、特に、裁判所、公的機関、および/または他の第三者からケルヒャーにその旨が通知された場合などです。ケルヒャーは、法令により許容される範囲において、遅滞なくお客様にその旨を通知するものとします。お客様アカウントの停止（ブロック）は、疑いが解消された後に解除されるものとします。
    </div>
  </div>
  <div class="contract-obligation-content__subheading">
    <div class="contract-obligation-content__text">第12条 責任</div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">12.1</div>
    <div class="contract-obligation-content__text">ケルヒャーは、故意または重過失による損害については、賠償責任の制限なく責任を負います。軽過失の場合、ケルヒャーは、ケルヒャーまたはケルヒャーの法定代理人、執行役員、もしくは履行補助者による重大な契約上の義務違反があった場合にのみ責任を負うものとします。この場合、ケルヒャーの賠償責任は、契約締結時に予見可能であった通常発生しうる損害に限定されるものとします。契約上の重大な契義務とは、その履行が契約の適切な履行の前提条件であり、お客様がその履行を信頼できるような義務をいいます。上記以外の場合においては、ケルヒャーは一切の責任を負わないものとします。
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__spacer"></div>
    <div class="contract-obligation-content__text">In all other cases, all liability of Kärcher shall be excluded.</div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">12.2</div>
    <div class="contract-obligation-content__text">上記第12.1条は、法律によって強制されるいかなる責任にも影響を与えるものではありません。
    </div>
  </div>
  <div class="contract-obligation-content__subheading">
    <div class="contract-obligation-content__text">第13条 期間および終了</div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">13.1</div>
    <div class="contract-obligation-content__text">本規約は、お客様による本規約の受諾時に発効し、無期限に有効であるものとします。 
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">13.2</div>
    <div class="contract-obligation-content__text">本規約は、いずれかの当事者が3ヶ月前に通知することにより、月の末日をもって終了させることができるものとします。
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">13.3</div>
    <div class="contract-obligation-content__text">上記は、いずれかの当事者が正当な理由により契約を終了させる権利に影響を与えないものとします。ケルヒャーは、特に、以下の場合に正当な理由により契約を終了させる権利を有するものとします。
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">13.3.1</div>
    <div class="contract-obligation-content__text">お客様が本規約の重大な条件に違反し、ケルヒャーが設定した是正期間内に適切な措置が講じられなかった場合、またはケルヒャーからの是正勧告にもかかわらず改善が見られなかった場合。
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">13.3.2</div>
    <div class="contract-obligation-content__text">その他、ケルヒャーが契約関係を維持することが社会通念上期待できない重大な理由がある範囲において。
    </div>
  </div>
  <div class="contract-obligation-content__subheading">
    <div class="contract-obligation-content__text">第14条 データ保護</div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">14.1</div>
    <div class="contract-obligation-content__text">両当事者は、個人データの保護に関する適用される法令、特に一般データ保護規則（GDPR）の規定を遵守するものとします。
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">14.2</div>
    <div class="contract-obligation-content__text">両当事者は、ケルヒャーが提供する機器データに基づくシステムキーデータと、お客様がカスタマーポータルに入力した追加情報との組み合わせ（該当する場合）には、お客様またはお客様の従業員、あるいは機器を操作するスタッフの個人データが含まれる可能性があることを認識しています。
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">14.3</div>
    <div class="contract-obligation-content__text">お客様は、カスタマーポータル内のデータ、特に個人データ（もしあれば）を合法的に処理する権利を有することを保証する。お客様は、個人データの処理に関する各許可が存在し、維持されることを保証します。
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">14.4</div>
    <div class="contract-obligation-content__text">	特に雇用関係において、お客様は、カスタマーポータルにおけるデータの収集および使用が適用されるデータ保護法に準拠していることを確認する単独の責任を負うものとします。
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">14.5</div>
    <div class="contract-obligation-content__text">カスタマーポータル内の個人データは、データ保護ポリシーに従い、お客様に代わってケルヒャーによってのみ処理されるものとします。
    </div>
  </div>
  <div class="contract-obligation-content__subheading">
    <div class="contract-obligation-content__text">第15条 秘密保持</div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">15.1</div>
    <div class="contract-obligation-content__text">両当事者は、契約およびその履行に関連して知り得た、秘密として指定されているか、または状況に照らして秘密とみなされなければならないすべての事実、情報、および文書（営業秘密を含む）（書面、電子的、有体物、または口頭形式を問わない）（以下、「秘密情報」という。）について、厳格かつ無条件の秘密保持を約束します。秘密情報には、特に、契約の存在およびその内容、ならびにデジタル的に具体化された情報（データ）、業務手順、および両当事者のノウハウが含まれるものとします。お客様が秘密保持義務を負う秘密情報には、さらに、AKWが単独で所有し、本規約第6条に従ってAKWおよびその関連会社が排他的に権利を有する機器データが含まれるが、これに限定されないものとします。
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">15.2</div>
    <div class="contract-obligation-content__text">本義務は、以下の事実、情報、および文書には適用されないものとします。 
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">15.2.1</div>
    <div class="contract-obligation-content__text">契約締結時に両当事者が既に知っていたことが証明可能であるか、またはその後、秘密保持契約、法令、もしくは公的命令に違反することなく第三者から知らされたもの。
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">15.2.2</div>
    <div class="contract-obligation-content__text">契約締結時に公知であるか、またはその後公知となったもの。ただし、これが契約違反による場合を除くものとします。
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">15.2.3</div>
    <div class="contract-obligation-content__text">法令上の義務、または裁判所もしくは公的機関の命令により開示しなければならないもの。許容されかつ実行可能な範囲で、開示を要求された当事者は、事前に相手方当事者に通知し、開示に対抗する機会を与えるものとします。さらに、当該当事者は、開示の過程で、関連情報が営業秘密を構成する場合はその旨を示し、ドイツ営業秘密法（GeschGehG）第16条以降の規定が利用されるように努めるものとします。
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">15.2.4</div>
    <div class="contract-obligation-content__text">秘密情報の知識または使用なしに、当事者の従業員によって開発されたもの。 
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">15.3</div>
    <div class="contract-obligation-content__text">両当事者は、秘密情報へのアクセスを、職業上の秘密保持義務を負う、または本規約に基づく秘密保持義務に実質的に対応する義務を事前に負ったコンサルタントおよびアドバイザーに限定するものとします。さらに、両当事者は、秘密情報を、自己の従業員およびその関連会社（ドイツ株式法（AktG）第15条以降で定義される「verbundene Unternehmen」）の従業員のうち、契約の履行のために当該情報を知る必要があり、かつ本規約に基づく秘密保持義務に実質的に対応する義務を事前に負った者にのみ開示し、これらの従業員に対し、雇用法上許容される範囲で、雇用終了後も秘密を保持するよう要求するものとします。
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">15.4</div>
    <div class="contract-obligation-content__text">両当事者は、データセキュリティおよび秘密情報の保護に関して最新技術水準を遵守する義務を負い、適切な技術的および組織的措置を実施することにより、かかる情報を保護するものとします。両当事者は、既存のセキュリティギャップおよびセキュリティギャップの脅威について相互に通知するものとします。両当事者は、従業員の選定および任命にあたり、随時活動する者がデータセキュリティ分野における最新技術水準を遵守し、すべての活動において秘密情報の秘密保持の必要性を考慮するように確認するものとします。
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">15.5</div>
    <div class="contract-obligation-content__text">お客様はさらに、秘密情報のリバースエンジニアリング、逆コンパイル、逆アセンブル、またはその他の方法でその構成および/または作成を調査しないことを約束いたします。ただし、これが契約上のサービスの履行に必要であり、かつケルヒャーが事前に書面による明示的な同意を与えた場合を除く。「リバースエンジニアリング」とは、秘密情報を取得することを目的として実行される、観察、テスト、調査、分解、および該当する場合は再構築を含むすべての行為を意味するものとします。
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">15.6</div>
    <div class="contract-obligation-content__text">理由の如何を問わず、契約が終了した場合、両当事者が取得したすべての秘密情報（作成されたすべてのコピーを含む）は返却されるか、または相手方当事者の要請に応じて削除および/または破棄されるものとします。削除および/または破棄の場合、秘密情報を復元できないように確保しなければならない。要請に応じて、各当事者は、秘密情報が完全に返却または削除および/または破棄されたことを書面で確認するものとします。前述の規定は、両当事者間の一般的な通信、または法令もしくは公的命令により両当事者による保持が要求される秘密情報には適用されないものとします。
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">15.7</div>
    <div class="contract-obligation-content__text">AKWが単独で所有し、本規約第6条に従ってAKWが排他的に権利を有する機器データは、引き渡しおよび削除の義務から免除されるものとします。
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">15.8</div>
    <div class="contract-obligation-content__text">両当事者の秘密保持義務は、契約期間中および契約終了後さらに5年間存続するものとします。
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">15.9</div>
    <div class="contract-obligation-content__text">ケルヒャーは、プレスリリースまたはその他の出版物において本規約に基づく両当事者の取引関係について報告する権利、またはお客様もしくはお客様の会社ロゴもしくは登録商標を参照として使用する権利を有するものとします。
    </div>
  </div>
  <div class="contract-obligation-content__subheading">
    <div class="contract-obligation-content__text">第16条 一般契約条件の変更</div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">16.1</div>
    <div class="contract-obligation-content__text">本規約は、契約締結時の事実関係および法的な状況を考慮して作成されたものです。これらの状況が変化した場合、特に、既存の強制的な法令規定の変更、または新たな強制的な法令規定の制定、もしくは管轄権を有する最高裁判所（例：ドイツ連邦裁判所（BGH））の判決があった場合、ケルヒャーは、変更された状況に合わせて本規約を修正する権利を有するものとします。これは、変更された状況により、本規約の規定に従った契約の履行が不合理となる場合にも適用されるものとします。
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">16.2</div>
    <div class="contract-obligation-content__text">ケルヒャーは、修正された本規約の発効日の少なくとも6週間前に、修正された本規約をテキスト形式でお客様に通知し、本規約の修正された条項を強調表示し、必要に応じて説明するものとします。通知は、カスタマーポータルでの告知または電子メールによって行われるものとします。
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">16.3</div>
    <div class="contract-obligation-content__text">お客様は、修正された本規約の発効日前に、テキスト形式で修正された本規約に異議を申し立てるか、または通知なしに契約を終了させることができるものとします。
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">16.4</div>
    <div class="contract-obligation-content__text">お客様が本規約第16.2条に記載された期間内に修正された本規約に異議を申し立てないか、または契約を終了させない場合、修正された本規約は当該期間の満了時に適用されるものとします。
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">16.5</div>
    <div class="contract-obligation-content__text">お客様が修正された本規約に異議を申し立てた場合、ケルヒャーは、修正された本規約の告知された発効日をもって契約を終了させる権利を有するものとします。
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">16.6</div>
    <div class="contract-obligation-content__text">ケルヒャーは、修正された本規約をお客様に通知する際、異議申し立ておよび契約終了の権利、ならびにお客様が異議を申し立てず契約も解約されなかった場合に期間満了時に生じる結果について、ご説明します
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">16.7</div>
    <div class="contract-obligation-content__text">本規約第13条の規定は、本第16条によって別途影響を受けないものとします。
    </div>
  </div>
  <div class="contract-obligation-content__subheading">
    <div class="contract-obligation-content__text">第17条 最終規定</div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">17.1</div>
    <div class="contract-obligation-content__text">本規約は、1980年4月11日の国際物品売買契約に関する国際連合条約（CISG）および抵触法の規定に関わらず、ドイツ連邦共和国の法律に準拠し、同法に従って解釈されるものとします。
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">17.2</div>
    <div class="contract-obligation-content__text">本規約からまたは本規約に関連して生じるすべての紛争に関する専属的裁判管轄地は、法令により許容される範囲において、ドイツのシュトゥットガルトとします。ただし、ケルヒャーは、お客様の事業所の所在地を管轄する裁判所に訴訟を提起する権利も有するものとします。
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">17.3</div>
    <div class="contract-obligation-content__text">本規約上のサービスは、本規約によってのみ規律されるものとします。お客様が提示される、本規約と矛盾相反するまたは逸脱する条件は、ケルヒャーが書面でその適用を明示的に承認しない限り、適用されないものとします。この原則は、は、ケルヒャーがお客様の相反するまたは逸脱する条件を認識しながら、何ら意義を留めることなく契約上のサービスを提供する場合にも適用されるものとします。
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">17.4</div>
    <div class="contract-obligation-content__text">上記第16条の範囲に含まれない本規約へのすべての変更および追加は、書面（Schriftform）で行われるか、または少なくとも単純もしくは高度な電子署名が付されているか、論理的に関連付けられている必要がある。これは、この書面形式に関する条項自体の変更にも適用されるものとします。付随的な合意はなされていないものとします。
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">17.5</div>
    <div class="contract-obligation-content__text">本規約に基づき行われるすべての通知は、契約で明示的に別段の合意がない限り、書面（Schriftform）で行われなければならないものとします。
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">17.6</div>
    <div class="contract-obligation-content__text">本規約のいずれかの条項が無効または実行不可能であるか、またはそうなった場合でも、本規約の残りの条項の有効性には影響しないものとします。無効または実行不可能な条項は、両当事者が当初意図したであろう、または無効性もしくは実行不可能性を認識していた場合に意図したであろう内容に対応する、法的に有効な条項に置き換えられるか、または補足されるものとします。本規約にいかなる欠缺（けんけつ）がある場合も同様とします。
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">17.7</div>
    <div class="contract-obligation-content__text">ケルヒャーは、本規約または本規約に基づく個々の権利もしくは義務を、ドイツ株式法（AktG）第15条以降で定義されるケルヒャーの関連会社（verbundene Unternehmen）のいずれかに譲渡する権利を有するものとします。その他のすべての場合において、譲渡は相手方当事者の書面による承認を条件とします。
    </div>
  </div>

  <div class="contract-obligation-content__heading">
    <div class="contract-obligation-content__text">General Terms and Conditions Governing the Use of the Kärcher Equipment Management Customer Portal (Terms and Conditions)</div>
  </div>
  <div class="contract-obligation-content__subheading">
    <div class="contract-obligation-content__index">1.</div>
    <div class="contract-obligation-content__text">General</div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">1.1</div>
    <div class="contract-obligation-content__text">These General Terms and Conditions of Contract (hereinafter, "Terms
      and Conditions" or "T&C") of Kärcher (Japan) Co., Ltd. (639-3 Mamedo-cho, Kohoku-ku, Yokohama, Kanagawa, Japan) (hereinafter also,
      "Kärcher") apply only to entrepreneurs, legal persons under private or public law or special funds under public
      law within the meaning of Section 310 (1) German Civil Code (BGB) (hereinafter, "Customer").
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">1.2</div>
    <div class="contract-obligation-content__text">If you are registering for the first time on the Kärcher customer
      portal and accepting these T&C on behalf of a Customer, you hereby represent and warrant to Kärcher that you have
      the authority to bind the Customer to these T&C. If you do not have such authority, or if you or the Customer does
      not consent to being bound to these T&C, you must not accept these T&C and neither you nor the Customer may use
      the contractual services.
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">1.3</div>
    <div class="contract-obligation-content__text">The Customer's general terms and conditions (if any) shall not
      apply.
    </div>
  </div>
  <div class="contract-obligation-content__subheading">
    <div class="contract-obligation-content__index">2.</div>
    <div class="contract-obligation-content__text">General information regarding the subject matter of the contract
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">2.1</div>
    <div class="contract-obligation-content__text">With its equipment management system, Kärcher offers its commercial
      Customers a web-based secure-access software application for easy fleet and machine management in the form of a
      customer portal.
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">2.2</div>
    <div class="contract-obligation-content__text">The individual data and functions that can be called up by the
      Customer in the customer portal depend on the machine model used by the Customer and on whether and, if so, what
      hardware module for data transmission is installed in that model. An overview of the functions of the respective
      hardware module and of the data that can be called up is contained in the specifications regarding the hardware
      module or will be made available to you by Kärcher upon request.
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">2.3</div>
    <div class="contract-obligation-content__text">The master data and basic functions of the customer portal
      (hereinafter, "Equipment Management") are available to the Customer even without a built-in hardware module for
      data transmission, both for Kärcher machines and for machines from other suppliers.
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">2.4</div>
    <div class="contract-obligation-content__text">To be able to use so-called "near-real-time" data and additional
      functions via the customer portal, the respective machine of the Customer must be equipped, or retrofitted, with a
      hardware module for data transmission.
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">2.5</div>
    <div class="contract-obligation-content__text">The Customer may enter its own additional customer-specific and
      machine-specific data into the customer portal, for example, the buildings to be cleaned, the cleaning times or
      other information about the use of the respective machine (hereinafter, "Portal Data").
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">2.6</div>
    <div class="contract-obligation-content__text">Kärcher shall grant the Customer access to, and enable the Customer
      to use, the customer portal.
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">2.7</div>
    <div class="contract-obligation-content__text">Once the customer account has been set up by Kärcher, the Customer
      can access the customer portal via the web address https://em.kaercher.com/. Access via the respective current
      versions of the Google Chrome, Microsoft Edge, Mozilla Firefox and Apple Safari web browsers and the Microsoft
      Windows operating system is supported. Access via other web browsers and operating systems may be restricted.
      Access via mobile devices is not supported.
    </div>
  </div>
  <div class="contract-obligation-content__subheading">
    <div class="contract-obligation-content__index">3.</div>
    <div class="contract-obligation-content__text">Formation of contract</div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">3.1</div>
    <div class="contract-obligation-content__text">Upon request, Kärcher will provide the Customer with access data
      (e.g. user, initial pass word) and the link to the portal. The Customer's request can be made without observing
      any particular form, for example, by telephone or e-mail. The Customer can then use the access data provided by
      Kärcher to log into the portal, consenting to these T&C in the process. The contract regarding the use of the
      equipment management system between Kärcher and the Customer is formed upon login and acceptance of these T&C. The
      contact person indicated in the Customer's request is registered in the customer account as administrator and, as
      such, can create further access rights for employees of the Customer in the customer account.
    </div>
  </div>
  <div class="contract-obligation-content__subheading">
    <div class="contract-obligation-content__index">4.</div>
    <div class="contract-obligation-content__text">Maintenance and availability</div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">4.1</div>
    <div class="contract-obligation-content__text">The accessibility of the customer portal is monitored Monday to
      Friday, 9am to 4pm CET (hereinafter also "Service Hours"), except on public holidays in Germany
      (Baden-Württemberg). In the event of serious faults - i.e. when the customer portal can no longer be used, or when
      its use is significantly restricted - maintenance measures will, within Service Hours, be initiated without undue
      delay upon knowledge of the fault or notification by the Customer. Kärcher will notify the Customer of any such
      maintenance work promptly via the customer portal or by e-mail and carry out the work in the shortest possible
      time in accordance with the technical conditions.
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">4.2</div>
    <div class="contract-obligation-content__text">The availability of the customer portal shall be 98% on an annual
      average, with the exception of maintenance periods.
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">4.3</div>
    <div class="contract-obligation-content__text">The provider may suspend the provision of the services outside
      Service Hours in order to carry out maintenance work. Kärcher will endeavour to notify the Customer of the exact
      maintenance period five days in advance, via the customer portal or by e-mail. In the event that any unscheduled
      and/or unforeseeable maintenance work or resolution of faults becomes necessary at other times and it is not
      reasonably possible for Kärcher to comply with the five-day notice period, Kärcher will notify the Customer as
      early as possible of the time and duration of the service interruption. During planned regular maintenance work
      ("Scheduled Maintenance Work"), the Customer shall have no right to demand to be able to use the software
      application.
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">4.4</div>
    <div class="contract-obligation-content__text">A fault to be remedied by Kärcher shall not be deemed to exist if
      there are problems with the data connection from the Customer and the Customer's users' devices to the Internet,
      for example, due to line failures or disruptions on the part of other providers or telecommunications companies,
      or if the system capacities provided are used in breach of the terms of this contract.
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">4.5</div>
    <div class="contract-obligation-content__text">In the event of problems with the connection between the cloud-based
      software application and the Customer's machines, the data of the respective machine may happen to be unavailable
      in the customer portal. If Kärcher is not responsible for the problems with the connection, the service shall not
      be deemed unavailable for the purposes of this contract. Such problems with the connection for which Kärcher is
      not responsible include, in particular, atmospheric disturbances, topographical factors or obstacles such as
      bridges, tunnels or buildings.
    </div>
  </div>
  <div class="contract-obligation-content__subheading">
    <div class="contract-obligation-content__index">5.</div>
    <div class="contract-obligation-content__text">Right to use the software application</div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">5.1</div>
    <div class="contract-obligation-content__text">Kärcher hereby grants the Customer the non-exclusive,
      non-transferable and non-sublicensable right to use the software application during the term of the contract in
      accordance with the provisions of these T&C.
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">5.2</div>
    <div class="contract-obligation-content__text">Information about the display of "near-real-time" data in the
      customer portal and further additional functions can be gathered from the specifications regarding the hardware
      module or will be made available by Kärcher upon request.
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">5.3</div>
    <div class="contract-obligation-content__text">The Customer shall have no right to grant third parties permission to
      use the software, whether for payment or free of charge, during the term of the contract. Persons using the
      services free of charge and as intended for fleet and machine management purposes on behalf of the Customer or
      based on a right of access granted by the Customer - for example, administrative users and employees of the
      Customer - shall not be deemed third parties. The Customer is thus expressly prohibited from subletting the
      software.
    </div>
  </div>
  <div class="contract-obligation-content__subheading">
    <div class="contract-obligation-content__index">6.</div>
    <div class="contract-obligation-content__text">Rights in Machine Data and Portal Data</div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">6.1</div>
    <div class="contract-obligation-content__text">Alfred Kärcher SE & Co. KG ("AKW") shall be the owner of the machine
      data collected by the hardware module for data transmission and processed in the customer portal (hereinafter,
      "Machine Data"), as well as the sole owner of all rights in and to such Machine Data. This shall apply
      irrespective of who owns the machine whose data is being collected.
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">6.2</div>
    <div class="contract-obligation-content__text">In addition, the Customer hereby grants AKW the non-exclusive and
      irrevocable right, unlimited in time and geographic scope, to use the Portal Data entered by the Customer in an
      anonymised form for internal purposes, in particular for market research and the improvement of products.
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">6.3</div>
    <div class="contract-obligation-content__text">If the processed data constitutes trade secrets of the Customer, the
      Customer hereby grants AKW and Kärcher a permanent, irrevocable, nonexclusive and non-transferable right to use
      such data in an anonymised form for their own business purposes (in particular, for analyses and evaluations with
      a view to improving the services under this contract and also other products of Kärcher). AKW and Kärcher will
      treat such data as strictly confidential, in accordance with clause 15 of these T&C.
    </div>
  </div>
  <div class="contract-obligation-content__subheading">
    <div class="contract-obligation-content__index">7.</div>
    <div class="contract-obligation-content__text">Customer's obligations</div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">7.1</div>
    <div class="contract-obligation-content__text">The Customer shall notify Kärcher of any faults or errors of the
      customer portal within a reasonable period of time after their occurrence, using the contact form provided in the
      customer portal or by e-mail to the service e-mail address provided in the customer portal.
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">7.2</div>
    <div class="contract-obligation-content__text">As part of its account information for the customer portal, the
      Customer shall indicate a contact person (administrator), who shall be available during normal business hours to
      answer any questions Kärcher may have with regard to the services under the contract and the contract itself. To
      the extent that the contact person is not available, the Customer shall indicate a replacement. The contact person
      and his or her replacement from time to time must be authorised to make decisions on behalf of the Customer with
      regard to the administration and use of the customer portal.
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">7.3</div>
    <div class="contract-obligation-content__text">Customer portal access rights may only be granted by the Customer to
      employees and representatives authorised by it. The Customer shall be obliged to keep the access rights secret and
      not make them accessible to third parties. The Customer shall impose corresponding obligations on its employees
      and representatives. The Customer shall further be obliged to notify Kärcher without undue delay of any potential
      misuse of access rights and accounts and other security incidents in connection with the customer portal.
    </div>
  </div>
  <div class="contract-obligation-content__subheading">
    <div class="contract-obligation-content__index">8.</div>
    <div class="contract-obligation-content__text">Fee</div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">8.1</div>
    <div class="contract-obligation-content__text">The Customer may use the Equipment Management of the customer portal
      free of charge.
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">8.2</div>
    <div class="contract-obligation-content__text">During the first five years following the provision of the hardware
      module, the use of the "near-real-time" data and of the additional functions in the customer portal that go beyond
      Equipment Management shall be deemed included in the price for the purchase of or, where applicable, the fee for
      the permission to use the hardware module for data transmission. Upon expiry of this five-year period, the right
      of use can be renewed subject to a fee.
    </div>
  </div>
  <div class="contract-obligation-content__subheading">
    <div class="contract-obligation-content__index">9.</div>
    <div class="contract-obligation-content__text">Modification of services</div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__text">Kärcher reserves the right to make adjustments to the services under
      the contract, to the extent necessary for technical reasons or due to a change in subcontractors. The modification
      of the services may not lead to any significant modification to the services or be otherwise unreasonable for the
      Customer. An extension of the scope of services by Kärcher shall be permitted at any time. However, Kärcher
      reserves the right to make an extended scope of services, such as new functions and features in the customer
      portal, only available to the Customer for use subject to an additional fee.
    </div>
  </div>
  <div class="contract-obligation-content__subheading">
    <div class="contract-obligation-content__index">10.</div>
    <div class="contract-obligation-content__text">Subcontractors</div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__text">Kärcher uses subcontractors to provide the services. Kärcher shall
      have absolute discretion as to the selection of subcontractors. However, Kärcher will select its subcontractors
      with due care, taking into account the Customer legitimate interests, to the extent known to Kärcher. The right to
      select subcontractors shall also include the right to replace subcontractors during the term of the contract,
      unless such a replacement would adversely affect the Customer's legitimate interests.
    </div>
  </div>
  <div class="contract-obligation-content__subheading">
    <div class="contract-obligation-content__index">11.</div>
    <div class="contract-obligation-content__text">Blocking the customer account in the event of an infringement of
      rights
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__text">Kärcher shall have the right to immediately block the customer
      account in the customer portal if there is reason to suspect that the collection or use of the data is unlawful or
      infringes third-party rights. In particular data processing activities performed in breach of the terms of the
      General Data Protection Regulation (GDPR) constitute an infringement of third-party rights (see clause 14 below in
      this respect). Reason to suspect that data has been collected or used unlawfully and/or that an infringement of
      rights has occurred shall especially be deemed to exist if Kärcher is so notified by a court, a public authority
      and/or another third party. Kärcher shall inform the Customer thereof without undue delay, to the extent permitted
      by law. The customer account shall be unblocked after the suspicion has been resolved.
    </div>
  </div>
  <div class="contract-obligation-content__subheading">
    <div class="contract-obligation-content__index">12.</div>
    <div class="contract-obligation-content__text">Liability</div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">12.1</div>
    <div class="contract-obligation-content__text">Kärcher shall be liable without limitation in the event of wilful
      misconduct or gross negligence. In the event of simple negligence, Kärcher shall only be liable upon violation of
      a material contractual obligation by Kärcher or by any of Kärcher's legal representatives, executive employees or
      vicarious agents. In this case, Kärcher's liability shall - in terms of the amount - be limited to the typical
      damage that could be foreseen at the time the contract was entered into. Material contractual obligations are
      obligations whose fulfilment is a prerequisite for the proper performance of the contract and may be relied upon
      by the Customer.
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__spacer"></div>
    <div class="contract-obligation-content__text">In all other cases, all liability of Kärcher shall be excluded.</div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">12.2</div>
    <div class="contract-obligation-content__text">Clause 12.1 above shall not affect any mandatory statutory
      liability.
    </div>
  </div>
  <div class="contract-obligation-content__subheading">
    <div class="contract-obligation-content__index">13.</div>
    <div class="contract-obligation-content__text">Term and termination</div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">13.1</div>
    <div class="contract-obligation-content__text">The contract shall take effect upon acceptance of these T&C by the
      Customer and shall be for an indefinite term.
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">13.2</div>
    <div class="contract-obligation-content__text">The contract may be terminated by either party with three months'
      notice, with effect at the end of a month.
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">13.3</div>
    <div class="contract-obligation-content__text">The above shall not affect the right of either party to terminate the
      contract for cause.
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__spacer"></div>
    <div class="contract-obligation-content__text">Kärcher shall, in particular, have a right to terminate the contract
      for cause:
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">13.3.1</div>
    <div class="contract-obligation-content__text">if the Customer violates material terms or conditions of the
      contract, provided that a deadline set by Kärcher for remedial action has expired without remedial action having
      been taken or that a required warning has been given to no avail;
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">13.3.2</div>
    <div class="contract-obligation-content__text">to the extent that Kärcher cannot reasonably be expected to adhere to
      the contractual relationship for any other serious reasons.
    </div>
  </div>
  <div class="contract-obligation-content__subheading">
    <div class="contract-obligation-content__index">14.</div>
    <div class="contract-obligation-content__text">Data protection</div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">14.1</div>
    <div class="contract-obligation-content__text">Both parties shall comply with the applicable statutory provisions
      regarding the protection of personal data, in particular the provisions of the General Data Protection Regulation
      (GDPR).
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">14.2</div>
    <div class="contract-obligation-content__text">The parties are aware that combinations of system key data based on
      the Machine Data provided by Kärcher and additional information entered by the Customer into the customer portal,
      where applicable, may contain personal data of the Customer or the Customer's employees, or of the staff operating
      the machines.
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">14.3</div>
    <div class="contract-obligation-content__text">The Customer guarantees that it has the right to lawfully process the
      data in the customer portal, in particular the personal data, if any. The Customer guarantees that the respective
      permissions for the processing of personal data exist and will be maintained.
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">14.4</div>
    <div class="contract-obligation-content__text">In particular in an employment context, the Customer shall be solely
      responsible for ensuring that the collection and use of data in the customer portal comply with the applicable
      data protection laws.
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">14.5</div>
    <div class="contract-obligation-content__text">The personal data in the customer portal will only be processed by
      Kärcher on behalf of the Customer, in accordance with the attached data processing agreement.
    </div>
  </div>
  <div class="contract-obligation-content__subheading">
    <div class="contract-obligation-content__index">15.</div>
    <div class="contract-obligation-content__text">Confidentiality</div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">15.1</div>
    <div class="contract-obligation-content__text">The parties undertake to maintain the strict and unconditional
      confidentiality of all facts, information and documents, including trade secrets, (in written, electronic,
      embodied or oral form) of which they obtain knowledge in connection with the contract and its performance and
      which are marked as confidential or must be regarded as confidential according to the circumstances (hereinafter,
      "Confidential Information"). The Confidential Information shall, in particular, include the existence of the
      contract and its contents, as well as any digitally embodied information (data), operational procedures and
      know-how of the parties. The Confidential Information to be kept confidential by the Customer shall further
      include, without limitation, the Machine Data that is the sole property of AKW and the rights in respect of which
      are owned exclusively by AKW and its affiliates pursuant to clause 6 of these T&C.
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">15.2</div>
    <div class="contract-obligation-content__text">This obligation shall not apply to facts, information and documents
      that:
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">15.2.1</div>
    <div class="contract-obligation-content__text">were demonstrably already known to the parties at the time the
      contract was entered into or are subsequently made known to them by a third party without violation of any
      confidentiality agreement, statutory provisions or official orders;
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">15.2.2</div>
    <div class="contract-obligation-content__text">are publicly known at the time the contract is entered into or are
      made publicly known thereafter, except where this is due to a breach of contract;
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">15.2.3</div>
    <div class="contract-obligation-content__text">must be disclosed due to statutory obligations, or by order of a
      court or public authority. To the extent permitted and feasible, the party required to make a disclosure shall
      notify the respective other party in advance and give it the opportunity to proceed against the disclosure.
      Furthermore, the party shall indicate in the course of disclosure that the relevant information constitutes trade
      secrets, where this is the case, and seek to ensure that the provisions of Sections 16 et seq. German Trade
      Secrets Act (GeschGehG) are made use of;
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">15.2.4</div>
    <div class="contract-obligation-content__text">were developed by an employee of the party without knowledge or use
      of Confidential Information.
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">15.3</div>
    <div class="contract-obligation-content__text">The parties shall limit access to Confidential Information to those
      consultants and advisors who are bound to professional secrecy or who have previously assumed obligations that
      substantially correspond to the confidentiality obligations under this contract. Furthermore, the parties shall
      disclose Confidential Information only to those of their own employees and of the employees of any of their
      affiliates (verbundene Unternehmen), as defined in Sections 15 et seq. German Stock Corporation Act (AktG), who
      need to know such information for the performance of the contract and have previously assumed obligations that
      substantially correspond to the confidentiality obligations under this contract, and they shall require these
      employees to maintain confidentiality even after their employment has ended, to the extent permitted under
      employment law.
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">15.4</div>
    <div class="contract-obligation-content__text">The parties shall be obliged to comply with the latest state of the
      art as regards data security and the protection of Confidential Information and shall protect such by implementing
      appropriate technical and organisational measures. The parties shall notify each other of any existing security
      gaps, and any threat of security gaps. They shall make sure when selecting and appointing their employees that the
      persons acting from time to time also observe the latest state of the art in the field of data security and have
      in all their activities regard to the need to maintain the confidentiality of the Confidential Information.
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">15.5</div>
    <div class="contract-obligation-content__text">The Customer additionally undertakes not to reverse engineer,
      decompile, disassemble or otherwise examine the composition and/or creation of Confidential Information, unless
      this is necessary for the performance of contractual services and Kärcher has given its express prior written
      consent. "Reverse engineering" shall mean all actions, including observing, testing, examining and deconstructing
      and, where applicable, reconstructing, performed with a view to obtaining Confidential Information.
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">15.6</div>
    <div class="contract-obligation-content__text">Upon termination of the contract, for whatever reason, all
      Confidential Information that has been obtained by the parties, including all copies made thereof, shall be
      returned or, at the request of the other party, be deleted and/or destroyed. In the event of deletion and/or
      destruction, it must be ensured that the Confidential Information cannot be reconstructed. Upon request, the
      respective party shall confirm in writing that the Confidential Information has been completely returned or
      deleted and/or destroyed. The preceding provisions shall not apply to general correspondence between the parties
      or to Confidential Information whose retention by the parties is required by law or official order.
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">15.7</div>
    <div class="contract-obligation-content__text">Any machine data that is the sole property of AKW and the rights in
      respect of which are owned exclusively by AKW pursuant to clause 6 of these T&C shall be exempt from the
      obligations to deliver and delete.
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">15.8</div>
    <div class="contract-obligation-content__text">The parties' obligation to maintain confidentiality shall exist for
      the duration of the contract and another five (5) years from the termination of the contract.
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">15.9</div>
    <div class="contract-obligation-content__text">Kärcher shall have the right to report on the parties' business
      relationship under the contract in press releases or other publications or use the Customer or the Customer's
      company logo or registered trademarks as a reference.
    </div>
  </div>
  <div class="contract-obligation-content__subheading">
    <div class="contract-obligation-content__index">16.</div>
    <div class="contract-obligation-content__text">Amendments to the General Terms and Conditions of Contract</div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">16.1</div>
    <div class="contract-obligation-content__text">These T&C have been drawn up in view of the factual and legal
      circumstances at the time of conclusion of the contract. In the event that these circumstances change, in
      particular in the event of changes to existing, or the creation of new, mandatory statutory provisions or rulings
      of the highest competent courts (e.g. the German Federal Court of Justice (BGH)), Kärcher shall have the right to
      amend these T&C in line with the changed circumstances. This shall also apply if the performance of the contract
      in accordance with the provisions of these T&C becomes unreasonable as a result of the changed circumstances.
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">16.2</div>
    <div class="contract-obligation-content__text">Kärcher shall notify the Customer in text form of the amended T&C,
      highlighting and, where necessary, explaining the amended provisions of the T&C, not less than six (6) weeks
      before the effective date of the amended T&C. The notification shall be made by means of an announcement in the
      customer portal or by e-mail.
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">16.3</div>
    <div class="contract-obligation-content__text">The Customer may object to the amended T&C in text form, or terminate
      the contract without notice, prior to the effective date of the amended T&C.
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">16.4</div>
    <div class="contract-obligation-content__text">If the Customer does not object to, or terminate, the amended T&C
      within the period of time mentioned in clause 16.2 of these T&C, the amended T&C shall apply upon expiry of said
      period.
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">16.5</div>
    <div class="contract-obligation-content__text">If the Customer objects to the amended T&C, Kärcher shall have the
      right to terminate the contract with effect from the announced effective date of the amended T&C.
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">16.6</div>
    <div class="contract-obligation-content__text">When notifying the Customer of the amended T&C, Kärcher shall advise
      the Customer of its rights to object and to terminate the contract, as well as of the consequence upon expiry of
      the deadline if the Customer does not object or terminate the contract.
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">16.7</div>
    <div class="contract-obligation-content__text">The provisions of clause 13 of these T&C shall not be otherwise
      affected by this clause 16.
    </div>
  </div>
  <div class="contract-obligation-content__subheading">
    <div class="contract-obligation-content__index">17.</div>
    <div class="contract-obligation-content__text">Final provisions</div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">17.1</div>
    <div class="contract-obligation-content__text">The contract shall be governed by, and construed in accordance with,
      the laws of the Federal Republic of Germany, without regard to the United Nations Convention of 11 April 1980 on
      Contracts for the International Sale of Goods (CISG) and without regard to the conflict-of-laws provisions.
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">17.2</div>
    <div class="contract-obligation-content__text">The exclusive place of jurisdiction for all disputes arising out of
      or in connection with the contract shall be Stuttgart, Germany, to the extent permitted by law. Kärcher shall,
      however, also have the right to initiate legal proceedings in the courts of competent jurisdiction over the
      Customer's place of business.
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">17.3</div>
    <div class="contract-obligation-content__text">The contractual services shall be governed exclusively by these T&C.
      Conflicting or deviating terms and conditions of the Customer shall not apply unless Kärcher expressly approves
      their application in writing. The rule in the first sentence above shall also apply if Kärcher provides
      contractual services without reservations whilst being aware of conflicting or deviating terms and conditions of
      the Customer.
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">17.4</div>
    <div class="contract-obligation-content__text">All changes and additions to the contract that do not fall within the
      scope of clause 16 above must be made in writing (Schriftform) or must at least have a simple or advanced
      electronic signature attached to them or logically associated with them. This shall also apply to changes to this
      written form clause. No ancillary agreements have been made.
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">17.5</div>
    <div class="contract-obligation-content__text">All notices to be given under the contract must be given in writing
      (Schriftform), except where expressly otherwise agreed by contract.
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">17.6</div>
    <div class="contract-obligation-content__text">Should any provision of the contract be or become invalid or
      impracticable, this shall not affect the validity of the remaining provisions of the contract. The invalid or
      impracticable provision shall be replaced or supplemented with a legally valid provision that corresponds to what
      the parties wanted or would have wanted if they had been aware of the invalidity or impracticability. The same
      shall apply to any gaps in the contract.
    </div>
  </div>
  <div class="contract-obligation-content__paragraph">
    <div class="contract-obligation-content__index">17.7</div>
    <div class="contract-obligation-content__text">Kärcher shall have the right to transfer the contract or individual
      rights or obligations under the contract to any of Kärcher's affiliates (verbundene Unternehmen), as defined in
      Sections 15 et seq. German Stock Corporation Act (AktG). In all other cases, transfers shall be subject to written
      approval by the respective other party.
    </div>
  </div>

  
</div>`,
};
